module.exports = __webpack_public_path__ + "img/document-agent-icon.924c0af1.svg";